export class Practice {
    id: number;
    name: string;
    members:any;
    invitations:any;
    owner:any;
    newImageB64:string;
    newImageType:string;
    media:any;
    mentors:any;
    mentor_invitations:any;
    limited;
    disabled;
    is_bacs_enabled;
    bacs;
    bacs_seats:number;
    bacs_renewal_date:any;
    constructor(practice?) {
        if (practice) {
            this.id = practice.id;
            this.name = practice.name;
            this.members = practice.members;
            this.invitations = practice.invitations;
            this.owner = practice.owner;
            this.media = practice.media;
            this.mentors = practice.mentors;
            this.mentor_invitations = practice.mentor_invitations;
            this.limited=practice.limited;
            this.disabled=practice.disabled;
            this.is_bacs_enabled=practice.is_bacs_enabled;
            this.bacs=practice.bacs;
            this.bacs_seats=practice.bacs_seats;
            this.bacs_renewal_date=(practice.bacs_renewal_date ? practice.bacs_renewal_date.slice(0, -9) : practice.bacs_renewal_date);
        }
    }
}
